module.exports = __webpack_public_path__ + "robotboy_4-d70a37a2e8a09e43a515042d1eb56cc0.png";